import { useState } from 'react';

import { Icon } from '../UI';
import { SortDirection, SortProps } from './types';
import { useTranslation } from 'react-i18next';

export const Sort = ({
  className,
  columnName,
  columnLabel,
  type,
  handleSort,
  columnClassName,
  initialDirection = 'sortUp',
}: SortProps) => {
  const [direction, setDirection] = useState<SortDirection>(initialDirection);
  const { t } = useTranslation();

  const handleDirection = () => {
    const newDirection =
      type === columnName
        ? direction === 'sortDown'
          ? 'sortUp'
          : 'sortDown'
        : direction;

    handleSort(columnName, newDirection);
    setDirection(newDirection);
  };

  return (
    <div className={className + ' cursor-pointer'} onClick={handleDirection}>
      <Icon
        className="mr-1"
        color={`${type !== columnName && 'grey-30'}`}
        svgName={direction}
      />
      <span className={columnClassName || ''}>
        {t(columnLabel || columnName)}
      </span>
    </div>
  );
};
